// import {useEffect, useRef} from 'react'
import './App.css'
import * as THREE from 'three'
import {Canvas} from '@react-three/fiber'
import {OrbitControls, PerspectiveCamera, Loader} from '@react-three/drei'
import {useCallback, useEffect, useState} from 'react'
import {button, Leva, useControls} from 'leva'
import {Experience} from './components/Experience.jsx'
import {InfoPanel} from './components/InfoPanel.jsx'
import {useAppStore} from './stores/store.js'
import {useGameStore} from './stores/gameStore.js'
import {INFO_PANEL_DATA} from './utils/constants.jsx'
import {strawberryJamCroissant} from './utils/easterEggs.jsx'
import {START_CAMERA_POS, START_TARGET_POS} from './utils/constants.jsx'
import {TabletInterface} from './components/TabletInterface.jsx'
import {IconBar} from './components/IconBar.jsx'
import {GameScore} from './components/GameScore.jsx'

function App() {

    const setControlsInstance = useAppStore((state) => state.setControlsInstance)
    const resetCameraAction = useAppStore((state) => state.resetCamera)
    const launchAnimationAction = useAppStore((state) => state.launchAnimation)
    const selectedObjectId = useAppStore((state) => state.selectedObjectId)
    const closePanelAction = useAppStore((state) => state.closePanel)

    const isTabletOpen = useAppStore((state) => state.isTabletOpen)

    const sceneReady = useAppStore((state) => state.sceneReady)
    const controlsReady = useAppStore((state) => state.controlsReady)

    const gameState = useGameStore((state) => state.gameState)

    const [isEasterEggSetup, setIsEasterEggSetup] = useState(false);

    useEffect(() => {
        // Only set up the global function once
        if (isEasterEggSetup || window.strawberryJamCroissant) return;

        console.log("Setting up console easter egg: Type 'unlockEverything()' in the console.");


        // Get the necessary actions from the store *inside* the function definition
        // Or get them once and pass them in if preferred
        window.strawberryJamCroissant = strawberryJamCroissant

        window.test = function () {
            console.log("%cThis text will be blue.", "color: red;");
            console.log("%cImportant Warning!", "color: red; font-size: 16px; font-weight: bold;");
            console.log("%cSuccess!", "color: green; background-color: #e0ffe0; padding: 2px 5px; border-radius: 3px; font-size: 60px; font-family: system-ui;");
            console.log(
                "Processing user %cJane Doe%c (ID: %c123%c)...",
                "color: purple; font-weight: bold;", // Style for "Jane Doe"
                "",                                  // Reset style for " (ID: "
                "color: blue; background: #eee; padding: 1px 3px;", // Style for "123"
                ""                                   // Reset style for ")..."
            );
            console.warn("%cThis is a styled warning.", "color: orange; text-decoration: underline;");
            console.error("%cCritical Error!", "color: white; background-color: red; font-size: 18px; padding: 5px;");
            console.info(
                "This is a styled info message.",
                "color: #000; background-color: #eee; padding: 5px; border-radius: 3px; font-family: HarmonyOS; font-size: 14px;")
            console.dir(
                {
                    name: "Jane Doe",
                    age: 25,
                    isAdmin: true,
                    friends: ["John", "Jane", "Jill"]
                },
                {
                    colors: true,
                    showHidden: false,
                })

            return "Test function executed!";
        }

        setIsEasterEggSetup(true); // Mark as setup

        // Optional cleanup (usually not necessary for this type of easter egg)
        // return () => {
        //   delete window.unlockEverything;
        // };

    }, [isEasterEggSetup]); // Dependency array ensures it runs once

    useEffect(() => {
        if (controlsReady && sceneReady) {
            launchAnimationAction()
        }
    }, [controlsReady, sceneReady, launchAnimationAction])


    const {backgroundColor} = useControls({
        backgroundColor: '#691313',
        'Reset Camera View': button(() => resetCameraAction()),
    })

    // --- Ref Callback for OrbitControls ---
    const orbitControlsRefCallback = useCallback((node) => {
        setControlsInstance(node) // Update the store with the instance
    }, [setControlsInstance])


    return (
        <>
            <div className='leva-thingy'>
                <Leva
                    fill
                    collapsed={true}
                    // hidden={true}
                />
            </div>

            <Canvas
                dpr={[1, 2]}
                // shadows={true}
                // flat
                gl={{
                    toneMapping: 4,
                    antialias: true,
                    outputColorSpace: THREE.SRGBColorSpace,
                    stencil: true
                }}
                /*onCreated={({gl}) => {
                    gl.setPixelRatio(window.devicePixelRatio)
                }}*/
            >
                <OrbitControls
                    ref={orbitControlsRefCallback}
                    name='orbit_controls'
                    makeDefault={true}
                    target={START_TARGET_POS.toArray()}
                />
                {/*<axesHelper args={[10]}/>*/}
                <color
                    attach='background'
                    args={[backgroundColor]}
                />
                <PerspectiveCamera
                    // ref={cameraRef}
                    name='camera'
                    makeDefault={true}
                    fov={45}
                    near={0.1}
                    far={200}
                    position={START_CAMERA_POS.toArray()}
                />
                <Experience/>

                {/* Center */}
                {/*<mesh position={[0, 5, 0]}>*/}
                {/*    <sphereGeometry args={[0.25, 12]}/>*/}
                {/*    <meshBasicMaterial color='#26998c'/>*/}
                {/*</mesh>*/}
            </Canvas>
            <IconBar/>
            {(gameState === 'playing' || gameState === 'ended') && (
                <GameScore/>
            )}

            {/* --- HTML Info Panel --- */}
            {selectedObjectId && (
                <div className='panel-container'>
                    <InfoPanel
                        data={INFO_PANEL_DATA[selectedObjectId] || {}}
                        onClose={closePanelAction}
                        onResetCamera={resetCameraAction}
                    />
                </div>
            )}
            {isTabletOpen && (
                <TabletInterface/>
            )}

            <Loader/>
        </>
    )
}

export default App
